import React from "react";
import { primaryActionColor, primaryTextColor } from "../../constants";
import { CircularProgress } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { AddFlex, CustomText } from "../../reusableStyles";
import { isNullOrUndefined } from "../../utils";
function InactiveChip({
  chipName,
  disableAction,
  showIcon,
  icon,
  padding,
  action,
  sessionAttendance,
  handleMarkAttandance,
  isLoading,
  fontSize,
  width,
  borderRadius,
}) {
  return (
    <AddFlex
      backgroundColor={"transparent"}
      alignItems="center"
      border={`1px solid ${primaryTextColor}`}
      padding={padding ? padding : "5px 10px"}
      borderRadius={borderRadius ? borderRadius : "25px"}
      onClick={() => {
        if (disableAction) return;
        if (isNullOrUndefined(action)) {
          handleMarkAttandance(!sessionAttendance);
        } else {
          action();
        }
      }}
      width={width}
    >
      <CustomText
        style={{
          borderRight: showIcon && "1px solid #ababab",
          paddingRight: "4px",
          flexGrow: 1,
        }}
        fontSize={fontSize ? fontSize : "12px"}
        textAlign="center"
        fontWeight="500"
        color={"#475466"}
        margin={showIcon && "0 5px 0 0"}
      >
        {chipName ? chipName : "Check-in"}
      </CustomText>

      {showIcon &&
        (isLoading ? (
          <>
            <CircularProgress
              size={14}
              color="info"
              style={{ color: primaryActionColor }}
            />
          </>
        ) : icon ? (
          icon
        ) : (
          <CheckCircleOutlineIcon
            style={{ paddingLeft: "0px", fontSize: "14px" }}
            color={"#475466"}
          />
        ))}
    </AddFlex>
  );
}

export default InactiveChip;
